
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_r2vco_12rwf_20",
  "dropdown-header": "awsui_dropdown-header_r2vco_12rwf_52",
  "dropdown-footer": "awsui_dropdown-footer_r2vco_12rwf_58"
};
  